export default __webpack_public_path__ + "static/media/bnb.a5a6857f.png";